module.exports = __webpack_public_path__ + "static/media/S-70B_Seahawk_Naval_Helicopter_01.ee984f98.jpg";